export const PRODUCTION_ORIGIN = "https://app.katana-crm.com";
export const BETA_RANK_ID = "S1Jq3vva4WiYk3SYOu3p";

const ENVIRONMENTS = {
  beta: { label: "Beta", icon: "mdi-flask-outline" },
  next: { label: "Next", icon: "mdi-rocket-launch-outline" },
};

export function getEnvironment(hostname = window.location.hostname) {
  const subdomain = hostname.split(".")[0];
  return ENVIRONMENTS[subdomain] ? { id: subdomain, ...ENVIRONMENTS[subdomain] } : null;
}

export function isPublicDocumentPath(path) {
  return /^\/record\/(quote|invoice)\//.test(path);
}
